<template>
  <div class="manageDetaList manageDetaListStyle">
    <!-- 搜索 -->
    <div class="manageDetaList-search" style="padding: 15rem 0px 4rem 0">
      <div class="search-fff">
        <el-form
          @submit.native.prevent
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="IP：">
            <el-input
              v-model="formInline.ip"
              class="formInput"
              placeholder="search for ip"
              @keyup.enter.native="seachEnter"
            ></el-input>
          </el-form-item>
          <el-form-item label="Time：">
            <el-date-picker
              v-model="timers"
              type="daterange"
              range-separator="to"
              start-placeholder="start time"
              end-placeholder="end time"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="changTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Country：">
            <el-input
              @keyup.enter.native="seachEnter"
              v-model="formInline.country"
              class="formInput"
              placeholder="search for country"
            ></el-input>
          </el-form-item>
          <el-form-item label="OS：">
            <el-input
              @keyup.enter.native="seachEnter"
              v-model="formInline.os"
              class="formInput"
              placeholder="search for os"
            ></el-input>
          </el-form-item>
          <el-form-item label="Vendor_model：">
            <el-input
              @keyup.enter.native="seachEnter"
              v-model="formInline.vender_model"
              class="formInput"
              placeholder="search for vendor_model"
            ></el-input>
          </el-form-item>
          <el-form-item label="Manager：">
            <el-input
              @keyup.enter.native="seachEnter"
              v-model="formInline.manager"
              class="formInput"
              placeholder="search for manager"
            ></el-input>
          </el-form-item>

          <el-form-item label="Platform：">
            <el-select
              placeholder="search for platform"
              class="formInput"
              v-model="formInline.platform"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="arm" value="arm"></el-option>
              <el-option label="mips" value="mips"></el-option>
              <el-option label="mips64" value="mips64"></el-option>
              <el-option label="x86_64" value="x86_64"></el-option>
              <el-option label="aarch64" value="aarch64"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Status：">
            <el-select
              placeholder="status"
              v-model="formInline.status"
              class="formInput"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="offline" value="0"></el-option>
              <el-option label="online" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Web ssh：">
            <el-select
              v-model="formInline.webssh_status"
              class="formInput"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="off" value="off"></el-option>
              <el-option label="on" value="on"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Camera：">
            <el-select
              v-model="formInline.camera_status"
              class="formInput"
              @change="changes"
            >
              <el-option label="whole" value=""></el-option>
              <el-option label="off" value="off"></el-option>
              <el-option label="on" value="on"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="searchClick()">search</el-button>
            <el-button @click="resetClick()">reset</el-button>
          </el-form-item>
        </el-form>
        <!-- <span @click="manageDetaListCilck">add manageDetaList</span> -->
      </div>
    </div>

    <!-- 表格 -->
    <div class="keshihua-table-three">
      <div class="manageDetaList-table">
        <el-table :data="tableData" ref="multipleTable" tooltip-effect="dark">
          <el-table-column
            label="Ser"
            type="index"
            :width="$globalProcessing.dateWidth(30)"
          >
          </el-table-column>

          <el-table-column
            prop="ip"
            label="IP"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="country"
            label="Country"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="os"
            label="OS"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="vender_model"
            label="Vendor_model"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="manager"
            label="Manager"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="platform"
            label="Platform"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="first_time"
            label="First time"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="last_time"
            label="Last time"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            show-overflow-tooltip
            align="center"
          >
            <span slot-scope="scope">
              {{ scope.row.status == '0' ? 'offline' : 'online' }}
            </span></el-table-column
          >
          <el-table-column
            label="Operation"
            :width="$globalProcessing.pxResponse(1920, 250)"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.webssh_status == '1'"
                type="text"
                size="small"
                class="btn-style blue"
                @click="ipReturn(scope.row)"
                >web ssh</span
              >
              <span
                v-if="scope.row.camera_status == '1'"
                type="text"
                size="small"
                class="btn-style blue"
                @click="cameraFun(scope.row.url, scope.row.ip)"
                >Camera</span
              >
              <!-- <el-button type="warning" @click="ipReturn(scope.row.ip)"
                >web ssh</el-button
              >
              <el-button type="warning" @click="cameraFun(scope.row.ip)"
                >Camera</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="manageDetaList-paging">
      <div class="pagination-fff">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.page"
          :page-sizes="[10, 30, 50]"
          :page-size="pages.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.total"
        ></el-pagination>
      </div>
    </div>
    <!-- 手动添加弹框 -->
    <div class="daping-dialog2">
      <!-- <manageDetaListAdd @newDialogFun="newDialogFun" ref="manageDetaListRef" /> -->
    </div>
  </div>
</template>

<script>
// 接口文件

import { getInfoList } from '@/api/manager';
import { hasopen } from '@/api/index';
// 手动添加组件
export default {
  name: 'manageDetaList',
  components: {},
  data: function () {
    return {
      editId: '',
      pages: {
        size: 10,
        page: 1,
        total: 0,
      },
      timers: null,
      formInline: {
        ip: '',
        country: '',
        os: '',
        vender_model: '',
        manager: '',
        platform: '',
        status: '',
        start_time: '',
        end_time: '',
        camera_status: '',
        webssh_status: '',
      },
      tableData: [],
      // tableList: [],
      selectList: [],
    };
  },
  created() {},
  mounted() {
    this.getmanageDetaListInfoFun();
  },

  methods: {
    ipReturn(row) {
      let rows = row;
      // let deUrl =
      //   'http://124.248.232.242:8080/xterm/index.html?' + 'id=' + rows.ip;
      let deUrl;
      if (row.vender_model == 'lexmark') {
        deUrl = '/printe/index.html?' + 'id=' + rows.ip;
      } else {
        deUrl = '/xterm/index.html?' + 'id=' + rows.ip;
      }

      hasopen({ ip: rows.ip, manager: rows.manager }).then((res) => {
        if (res.data.code == 200) {
          window.open(deUrl);
        } else {
          this.$globalProcessing.reportErrors.error(res.data.msg);
        }
      });
    },
    cameraFun(row, ip) {
      // let deUrl = '/xterm/index.html?';
      window.open(row);
    },
    seachEnter(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getmanageDetaListInfoFun();
      }
    },
    changes() {
      this.$forceUpdate();
    },
    changTime(val) {
      this.formInline.start_time = val[0];
      this.formInline.end_time = val[1];
    },
    handleSelectionChange(val) {
      // let arr = val;
      // arr.forEach((item) => {
      //   this.check.push(item.id);
      // });
      // console.log(this.check);
    },

    // 表格请求接口
    getmanageDetaListInfoFun() {
      // 深克隆数据
      let formInlineData = this.$globalProcessing.depthCopy(this.formInline);
      let pageData = this.$globalProcessing.depthCopy(this.pages);
      formInlineData.manager = this.$route.query.ip;
      // pageData.page = pageData.page - 1;
      getInfoList({ ...formInlineData, ...pageData }).then((res) => {
        if (res.data.code == 200) {
          this.pages.total = res.data.data.total;
          this.tableData = res.data.data.data;
        } else {
          this.$globalProcessing.reportErrors.error(res.data.msg);
          this.tableData = [];
        }
      });
    },
    // 当前页
    handleCurrentChange(data) {
      this.pages.page = data;
      this.getmanageDetaListInfoFun();
    },
    // 当前页条数
    handleSizeChange(data) {
      this.pages.page = 1;
      this.pages.size = data;
      this.getmanageDetaListInfoFun();
    },
    // 搜素
    searchClick() {
      this.pages.page = 1;
      this.getmanageDetaListInfoFun();
    },
    // 重置
    resetClick() {
      this.formInline = {};
      this.formInline.status = '';
      this.formInline.platform = '';
      this.formInline.camera_status = '';
      this.formInline.webssh_status = '';
      // this.dateFun();
      this.pages.page = 1;
      this.getmanageDetaListInfoFun();
    },
    manageDetaListCilck() {
      this.$refs.manageDetaListRef.appLicModel = true;
      this.editId = '';
    },
    // 点击编辑按钮
    editClick(id) {
      this.editId = id;
      this.$refs.manageDetaListRef.appLicModel = true;
    },
    // 关闭弹框
    newDialogFun(type) {
      if (type) {
        this.getmanageDetaListInfoFun();
      }
      // type为false不刷新页面，true刷新
      this.newDialog = false;
      this.editId = '';
    },

    // 删除
    delClick(val) {
      this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          getDelt({ id: val.id }).then((res) => {
            if (res.data.result) {
              this.$globalProcessing.reportErrors.success('删除成功');
              this.getmanageDetaListInfoFun();
            } else {
              this.$globalProcessing.reportErrors.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$globalProcessing.reportErrors.message('已取消删除');
        });
    },
  },
};
</script>

<style scoped lang="less">
// tabs 切换颜色
/deep/.el-tabs__item {
  color: black;
  font-size: 16rem;
}
// form字体大小
/deep/.el-form-item .el-form-item__label {
  font-size: 15rem;
}
/deep/.el-table tr {
  height: 50px;
}
.search-fff {
  position: relative;
  span {
    position: absolute;
    right: 0;
    top: 3%;
    padding: 10rem 20px;
    color: #546afc;
    border-radius: 10rem 10rem;
    float: right;
    background: #e8efff;
    cursor: pointer !important;
  }
}

.manageDetaListStyle {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;

  .keshihua-table-three {
    flex: 1;
    position: relative;
    .manageDetaList-table {
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      .red {
        color: #fe4e4e;
        background: #ffe6e7;
      }
      .blue {
        color: #546afc;
        background: #e8efff;
      }
      .btn-style {
        padding: 6rem 20rem;
        border-radius: 10rem 10rem;
        display: inline-block;
        cursor: pointer;
        margin: 0 5rem;
        // border-radius: 10%;
      }
    }
  }
  .blue {
    color: #546afc;
    background: #e8efff;
  }
  .btn-style {
    padding: 6rem 20rem;
    border-radius: 10rem 10rem;
    display: inline-block;
    cursor: pointer;
    margin: 3rem 5rem;
    // border-radius: 10%;
  }
}
</style>
